export const DOCUMENT_CREATE_REQUEST = 'DOCUMENT_CREATE_REQUEST'
export const DOCUMENT_CREATE_SUCCESS = 'DOCUMENT_CREATE_SUCCESS'
export const DOCUMENT_CREATE_FAIL = 'DOCUMENT_CREATE_FAIL'
export const DOCUMENT_CREATE_CLEAR = 'DOCUMENT_CREATE_CLEAR'

export const DOCUMENTS_LIST_REQUEST = 'DOCUMENTS_LIST_REQUEST'
export const DOCUMENTS_LIST_SUCCESS = 'DOCUMENTS_LIST_SUCCESS'
export const DOCUMENTS_LIST_FAIL = 'DOCUMENTS_LIST_FAIL'

export const GET_DOCUMENT_REQUEST = 'GET_DOCUMENT_REQUEST'
export const GET_DOCUMENT_SUCCESS = 'GET_DOCUMENT_SUCCESS'
export const GET_DOCUMENT_FAIL = 'GET_DOCUMENT_FAIL'

export const DELETE_DOCUMENT_REQUEST = 'DELETE_DOCUMENT_REQUEST'
export const DELETE_DOCUMENT_SUCCESS = 'DELETE_DOCUMENT_SUCCESS'
export const DELETE_DOCUMENT_FAIL = 'DELETE_DOCUMENT_FAIL'
